<p class="label-form">{{label}}</p>
<div class="spacer"></div>
<input #field [(ngModel)]="value" (ngModelChange)="valueChanged()" [placeholder]="placeholder" [type]="type"  [required]="required" [attr.min]="min" [attr.max]="max" [ngClass]="{'invalid': invalid}" />
@if (invalid) {
  <p class="error">{{errorText}}</p>
}
